import React from "react";
import { format } from "date-fns";
import TextField from "@material-ui/core/TextField";
import MatUITable from "../../../components/MatUITable/MatUITable";
import Heading from "../../../components/Heading/Heading";
import { AdminDashboardContext } from "../AdminDashboard";

function AdminMessages() {
  const [filterBy, setFilterBy] = React.useState({
    name: "",
  });
  const handleChange = (event) => {
    setFilterBy({ ...filterBy, [event.target.id]: event.target.value });
  };
  const adminDashboardContext = React.useContext(AdminDashboardContext);

  const createTableData = (messages) => {
    let rowData = [];
    messages.forEach((item) => {
      adminDashboardContext.state.userAccounts.forEach((account) => {
        if (item.userID === account.userID) {
          item.name = `${account.firstname} ${account.lastname}`;
        }
      });
      let match = true;
      for (let i in filterBy) {
        if (item[i] !== undefined) {
          let value = item[i].toLowerCase();
          let filter = filterBy[i].toLowerCase();
          if (filterBy[i].length !== 0 && !value.match(`${filter}`)) {
            match = false;
          }
        }
      }
      for (let key in item.threads) {
        let msgArr = item.threads[key].messages;
        let length = msgArr.length;
        if (length > 0 && match) {
          let seen =
            msgArr[length - 1].sender === "user"
              ? msgArr[length - 1].seen
              : true;
          rowData.push({
            threadID: item.threads[key]._id,
            threadIDDisplay: item.threads[key]._id,

            sent: format(new Date(msgArr[length - 1].date), "yyyy-MM-dd"),

            message: `${msgArr[length - 1].message.substring(0, 20)} ...`,
            dialogData: item.threads[key],
            seen: seen,
            userID: item.userID,
            name: item.name,
          });
        } else if (match) {
          rowData.push({
            threadID: item.threads[key]._id,
            threadIDDisplay: item.threads[key]._id,
            sent: format(new Date(), "yyyy-MM-dd"),
            message: "No messages yet",
            dialogData: item.threads[key],
            name: item.name,
            userID: item.userID,
          });
        }
      }
    });
    return rowData;
  };

  return (
    <div>
      <div className="MarginHorizontal Row">
        <TextField
          className="MarginRight"
          id="name"
          placeholder="Client Name"
          variant="outlined"
          value={filterBy["name"]}
          onChange={(event) => handleChange(event)}
        />
      </div>
      <Heading title="Messages" className="ToreaBay Medium" />
      <MatUITable
        updateMessages={() =>
          adminDashboardContext.getMessagesFromDB(localStorage.getItem("JWT"))
        }
        paging={true}
        page="adminmessage"
        pageSize={10}
        columns={[
          {
            title: "ThreadID",
            field: "threadIDDisplay",
            align: "left",
            render: (rowData) => {
              return (
                <span className={!rowData.seen ? "Bold" : ""}>
                  {rowData.threadIDDisplay}
                </span>
              );
            },
          },
          {
            title: "Sent",
            field: "sent",
            align: "left",
            defaultSort: "desc",
          },
          {
            title: "Name",
            field: "name",
            align: "left",
            render: (rowData) => {
              return (
                <span className={!rowData.seen ? "Bold" : ""}>
                  {rowData.name}
                </span>
              );
            },
          },
          {
            title: "Message",
            field: "message",
            align: "left",
            render: (rowData) => {
              return (
                <span className={!rowData.seen ? "Bold" : ""}>
                  {rowData.message}
                </span>
              );
            },
          },
        ]}
        data={createTableData(adminDashboardContext.state.messages)}
      />
    </div>
  );
}

export default AdminMessages;
